<button
  type="button"
  class:mh-menu-closed="{!menuOpen}"
  on:click
  class="{className}"
  aria-expanded="{menuOpen}"
  aria-controls="mh-mobile-navigation"
>
  <span class="mh-sr-only">Menu</span>
  <span class="mh-icon-bar"></span>
  <span class="mh-icon-bar"></span>
  <span class="mh-icon-bar"></span>
</button>

<style lang="less">
  button {
    display: inline-block;
    border: none;
    background-color: transparent;
    position: relative;
    z-index: 1;
    padding: 0 0 1px 9px;
  }

  button:focus {
    outline: 0;
  }

  .mh-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .mh-icon-bar {
    background-color: currentColor;
    border-radius: 1px;
    display: block;
    height: 3px;
    width: 22px;
    transform-origin: 21px;
    transition: -webkit-transform 0.2s;
    transition: transform 0.2s;
    transition: transform 0.2s, -webkit-transform 0.2s;
  }

  .mh-icon-bar + .mh-icon-bar {
    margin-top: 4px;
  }

  .mh-icon-bar:nth-child(3) {
    transition: opacity 0.2s;
  }

  button:not(.mh-menu-closed) .mh-icon-bar:nth-child(2) {
    transform: rotate(-45deg) /* rtl:ignore */;
  }

  button:not(.mh-menu-closed) .mh-icon-bar:nth-child(3) {
    opacity: 0;
  }

  button:not(.mh-menu-closed) .mh-icon-bar:nth-child(4) {
    transform: rotate(45deg) /* rtl:ignore */;
  }
</style>

<script>
  export let menuOpen = false;
  export let className = '';
</script>
